import { useEffect, useState } from "react";
import { GridTable, LoadingBox, PrivilegesChecker } from "..";
import {
  PageEnum,
  RequestActionModel,
  LookupItemModel,
  LookupTypeEnum,
  TableActionColumnsStyleEnum,
  ActionTypeEnum,
} from "../../models";
import { isArabicCurrentLanguage, scrollToDocumentTop } from "../../utils";
import { SearchTransactionDueDateFields } from "./searchTransactionDueDateField";
import { getLookupByType } from "../../serviceBroker/lookupApiServiceBroker";
import { useTransactionDueDate } from "../../hooks/transactionDueDate/useTransationDueDate";
import { useSearchParams } from "react-router-dom";

export const TransactionDueDateList = () => {
  const isArabic = isArabicCurrentLanguage();

  let [_, setSearchParams] = useSearchParams();

  const [customerList, setCustomerList] = useState<LookupItemModel[]>([]);

  // Use our simplified hook
  const {
    data,
    loading,
    searchParams,
    totalCount,
    fetchData,
    updateSearchParam,
    resetSearch,
    onCurrentPageChange,
    onPageSizeChange,
  } = useTransactionDueDate();

  // Load initial data and customer list
  useEffect(() => {
    const initialize = async () => {
      // Load customers for dropdown
      try {
        const customers = await getLookupByType(
          LookupTypeEnum.Customers,
          true,
          false
        );
        setCustomerList(customers || []);
      } catch (error) {
        console.error("Error loading customers:", error);
      }

      // Load initial data
      fetchData();
    };

    initialize();
  }, []);
  // Action resolver function - determines which actions are available for each row

  const handleSearch = () => {
    fetchData();
  };

  const handleReset = () => {
    resetSearch();
    fetchData({});
  };

  function handleUpdate(event: number | string) {
    const encodedId = btoa(event.toString()); // Base64 encode
    setSearchParams({
      id: encodedId,
    });
    scrollToDocumentTop();
  }
  const onActionEvent = (e: RequestActionModel) => {
    if (
      e.action === ActionTypeEnum.View ||
      e.action === ActionTypeEnum.Update
    ) {
      handleUpdate(e?.id || "");
      return;
    }
  };

  return (
    <LoadingBox isLoading={loading}>
      <PrivilegesChecker
        formId={PageEnum.ManageTransactionDueDate}
        action="EnableSearch"
      >
        <SearchTransactionDueDateFields
          searchParams={searchParams}
          onUpdateSearchParam={updateSearchParam}
          onSearch={handleSearch}
          onReset={handleReset}
          customerList={customerList}
          loading={loading}
        />
      </PrivilegesChecker>
      <GridTable
        data={data}
        totalRows={totalCount}
        currentPage={searchParams.pageNumber || 1}
        pageSize={searchParams.pageSize || 50}
        onCurrentPageChange={onCurrentPageChange}
        onPageSizeChange={onPageSizeChange}
        paginationType="server"
        externalLoading={loading}
        formId={PageEnum.ManageTransactionDueDate}
        columnsProps={{
          actions: [ActionTypeEnum.Update],
          onActionEvent,
          isArabic,
        }}
        style={TableActionColumnsStyleEnum.Dropdown}
        useRowBasedActions={true}
      />
    </LoadingBox>
  );
};
